function AdminMainPage({ isSignIn }: { isSignIn: boolean }) {
    console.log(isSignIn);
    return <div className="flex flex-1  min-h-screen scroll-auto bg-gray-800 px-4 py-8 flex-col space-y-6 justify-center">
        {isSignIn ? null
            : <div className="flex flex-col text-menu text-center font-bold space-y-4">
                <span>Welcome to Percent Map web admin framework</span>
                <span>Sign in to continue...  Happy coding!</span>
            </div>}
    </div>
}

export { AdminMainPage };